import React, { useState } from 'react';
import { Alert, Button, Col, Dropdown, Badge, Row } from 'react-bootstrap';
import { Funnel } from 'react-bootstrap-icons';
import { ORG_ROLES, SERVICES_SORT_BY_OPTIONS } from '../../../helpers/constants';
import AdditionalFilterGroupCheck from './AdditionalFilterGroupCheck';

const ServiceAdditionalFilters = ({
  filterOptions = [],
  filterValues = {},
  onFilterValueChange,
  onAllFilterCheckChange,
  onEnableFilterCheckChange,
  onShowFilterSidebarChange,
  serviceSortOption,
  onServiceSortOptionChange,
  taskServicePicker = false,
  isSideBarFilterApplied = false
}) => {
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const [role] = useState(localStorage.getItem('user-role'));

  return (
    <Row>
      <Col md={5} xs={12}>
        <h6 className="mb-0 mx-2 text-muted xtinyFont">Order Status</h6>
        <Alert className="px-2 py-1 relative" variant="dark">
          <div className="d-flex justify-content-start align-items-center">
            <h6 className="mb-0 mx-2 text-dark xtinyFont">Includes Order:</h6>
            {filterOptions
              .filter(f => f.key !== 'Common')
              .map(option => (
                <Badge
                  style={{ fontSize: 11 }}
                  variant={filterValues[option.key].enabled ? 'primary' : 'light'}
                  className={`text-dark  hover-dark hover-text-dark  p-1 ml-3`}
                  onClick={() => {
                    onEnableFilterCheckChange(option.key);
                    //if all of them are unchecked then
                  }}
                >
                  {option.label}
                </Badge>
              ))}
          </div>
        </Alert>
      </Col>
      <Col md={4} xs={12} className={`w-100 mb-3`}>
        <h6 className="mb-0 mx-2 text-muted xtinyFont">Sort By</h6>
        <div className="mb-0 my-auto d-flex justify-content-between align-items-center">
          <div className="flex-grow-1">
            <Dropdown>
              <Dropdown.Toggle size="sm" disabled={false} block variant="outline-dark" id="dropdown-basic">
                {serviceSortOption.label}
              </Dropdown.Toggle>

              <Dropdown.Menu value={serviceSortOption.key}>
                {SERVICES_SORT_BY_OPTIONS.map(o => (
                  <Dropdown.Item
                    value={o.label}
                    onClick={() => onServiceSortOptionChange(o)}
                    disabled={o.key === serviceSortOption.key}
                  >
                    {o.label}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>

          <div className="ml-2 px-0 w-25  relative">
            {isSideBarFilterApplied && (
              <div
                style={{
                  position: 'absolute',
                  top: '15px',
                  right: '20px',
                  width: 10,
                  height: 10,
                  backgroundColor: 'yellow',
                  borderRadius: '50%'
                }}
              ></div>
            )}
            <Button size="sm" variant="dark" block disabled={false} onClick={() => onShowFilterSidebarChange(true)}>
              <Funnel size={16} className="align-middle" />
            </Button>
          </div>
        </div>
      </Col>
      <Col md={12}>
        <AdditionalFilterGroupCheck
          filterOptions={filterOptions}
          filterValues={filterValues}
          onAllFilterCheckChange={onAllFilterCheckChange}
          onFilterValueChange={onFilterValueChange}
        />
      </Col>
    </Row>
  );
};

export default ServiceAdditionalFilters;
